export { dataAdapter } from './pricingEditor.adapters'
